module.exports = __webpack_public_path__ + "img/Kia-ev6.09584e93.jpg";